<template>
  <span v-if="canSeeAction">
    <WdsStack gap-sm :data-test="`compliance-actions-${index}`">
      <WdsButtonGhost sm :primary="isReview" @click="emitReview">
        {{ isReview ? $t('Review') : $t('View') }}
      </WdsButtonGhost>
    </WdsStack>
  </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsButtonGhost, WdsStack } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { user } from '@/composables/useUser'

const ComplianceActionsColumn = graphql(`
  fragment ComplianceActionsColumn on TrustedContact {
    id
    verifiedCompliance: compliances(names: [VERIFIED_WORKER_COMPLIANCE], cached: true) {
      name
      applicable
      completed
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof ComplianceActionsColumn>
  index: number
}>()

const emit = defineEmits<{
  review: [trustedContact: { id: string }]
}>()

const column = computed(() => useFragment(ComplianceActionsColumn, props.row))

const canSeeAction = computed(() => user.value.hasPermission('view-compliance-tracker'))

const isReview = computed(() => {
  if (!user.value.hasPermission('manage-compliance-tracker')) {
    return false
  }

  const comp = column.value.verifiedCompliance?.[0]
  if (!comp) {
    return false
  }

  return comp.applicable && !comp.completed
})

function emitReview() {
  emit('review', { id: column.value.id })
}
</script>
